module.exports = __webpack_public_path__ + "static/media/speaking.f6c818c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/speaking.jpg
// module id = 570
// module chunks = 6